import axios from "axios";
import { baseUrl } from "../../../../boot";
export const ShipmentOrdersApi = async (formatData) => {
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/stallion/api/v1/create-orders`, formatData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("shipment  orde api :", response);
    return response;
  } catch (error) {
    console.error("Error fetching rates:", error.response?.data || error.message);
    return null;
  }
};

export const CreateShipmentApi = async (formatData) => {
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/stallion/api/v1/create-shipment`, formatData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("shipment  orde api :", response);
    return response;
  } catch (error) {
    console.error("Error fetching rates:", error.response?.data || error.message);
    return null;
  }
};
